import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
} from "@mui/material";
import Button from "../Button/Button";

interface ConfirmDialogProps extends DialogProps {
  okLabel?: string;
  cancelLabel?: string;
  disableOk?: boolean;
  onClickOk: () => void;
  onClickClose: () => void;
}

function ConfirmDialog(props: ConfirmDialogProps) {
  const {
    children,
    onClickOk,
    onClickClose,
    open,
    title,
    disableOk = false,
    okLabel = "OK",
    cancelLabel = "キャンセル",
  } = props;

  const handleOk = () => {
    onClickOk();
  };

  return (
    <Dialog open={open}>
      <DialogTitle>
        <span>{title}</span>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClickClose} variant="outlined" sx={{ mr: 1 }}>
          {cancelLabel}
        </Button>
        <Button disabled={disableOk} onClick={handleOk}>
          {okLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmDialog;
